<template>
  <div class="usr-menu-box">
    <div class="usr-header">
      <div class="icon">
        <img :src="safeUsr.avatar && safeUsr.avatar.length > 0 ? safeUsr.avatar: require('../../assets/images/headericon/headimg.png')" />
      </div>
      <div class="inf">
        <p>{{ safeUsr.nickname }}</p>
        <p class="usr-id">ID:{{ safeUsr. id}}<a style="margin-left: 5px;color:#cca352;" @click="copy(safeUsr. id)">复制</a></p>
        <span>{{ safeUsr.balance }}</span>
      </div>
      <div class="arrow" @click="$router.push({ name: 'mine'});">账户<van-icon name="arrow" /></div>
      <div style="clear: both" />
    </div>
    <div class="btns">
      <van-row>
        <van-col span="12">
          <div class="btn">
            <div
              class="icon-btn icon-recharge"
              style="float: left; margin-top: 0.24rem; margin-left: 0.8rem"
            />
            <span style="margin-left: -20px" @click="$router.push({ name: 'recharge'});">充值</span>
          </div>
        </van-col>
        <van-col span="12">
          <div class="btn">
            <div
              class="icon-btn icon-withdraw"
              style="float: left; margin-top: 0.24rem; margin-left: 0.8rem"
            />
            <span style="margin-left: -20px" @click="$router.push({ name: 'withdraw'});">提现</span>
          </div>
        </van-col>
      </van-row>
    </div>
    <div class="cols">
      <van-cell :border="false" v-for="(item,index) in menu" :key="index" :title="item.label" is-link :to="item.key" />
    </div>
    <div class="customer-btn" @click="openNativePage()">
        在线客服
    </div>
    <div class="usdt-des">
        支持数字币存取<span>安全·便捷·秒到账</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WebUsrMenu',
  props:['usr'],
  computed:{
    safeUsr(){
      return this.usr || {}
    }
  },
  data(){
    return {
        menu:[
            {key:'home',label: this.$t('menu.home')},
            {key:'active',label: this.$t('menu.active')},
            {key:'task',label: this.$t('menu.task')},
            {key:'vip',label: this.$t('menu.vip')},
           // {key: 'share',label:this.$t('menu.share')}
        ],
        url:null
    }
  },
  watch:{
    usr(val){
      if(val.isagent == 1){
        this.menu = [
            {key:'home',label: this.$t('menu.home')},
            {key:'active',label: this.$t('menu.active')},
            {key:'task',label: this.$t('menu.task')},
            {key:'proxy',label: '代理'},
            {key:'vip',label: this.$t('menu.vip')},
        ]
      }
    },
  },
  mounted(){
    // this.getagenturl()
  },
  methods:{
     checkDevice () {
      const u = navigator.userAgent
      return {
        isAndroid: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1
      }
    },
    isIOS () {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera
      return /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
    },
    callAndroidMethod (method, params) {
      if (window.Android && typeof window.Android[method] === 'function') {
        window.Android[method](JSON.stringify(params))
      } else {
        this.$toast.fail('Android方法未注入')
      }
    },
    callIOSMethod (method, params) {
      if (window.webkit && window.webkit.messageHandlers[method]) {
        window.webkit.messageHandlers[method].postMessage(
          JSON.stringify(params)
        )
      } else {
       this.$toast.fail('iOS方法未注入')
      }
    },
    openNativePage () {
      const device = this.checkDevice()
      if (device.isAndroid) {
        // this.callAndroidMethod('toKeFu', { page: 'toKeFu' })
        //window._dsbridge.toKeFu('')
        let targetUserId = ''; 
        let apiObjectName = '_dsbridge';
        if (window[apiObjectName] && window[apiObjectName].toKefu) {
          window[apiObjectName].toKefu(targetUserId); 
        } else {
          this.$toast.fail('Android方法未注入')
        }

      } else if (this.isIOS()) {
        if(window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.openBrowser){
          try {
            window.webkit.messageHandlers.openBrowser.postMessage('tokefu');
          } catch (error) {
            this.$toast.fail('IOS方法调用失败')
          }
        } else {
          this.$toast.fail('IOS方法未注入')
        }
        // this.callIOSMethod('toKeFu', { page: '' })
      } else {
        this.$router.push({ name: 'news'});
      }
    },
    copy (val) {
      var input = document.createElement('input')
      input.value = val
      document.body.appendChild(input)
      input.select()
      document.execCommand('copy')
      this.$toast.success('复制成功')
      document.body.removeChild(input)
    },
    async getagenturl () {
      await this.$http({
        method: 'get',
        url: 'getAgentLoginUrl'
      }).then(data => {
        this.url = data.data.url
      })
    },
  }
}
</script>
<style lang="scss" scoped>
.usr-menu-box {
  padding: 10px;
  color: #999;
  text-align: left;
  height: calc(100vh - 20px);
  width: calc(100% - 20px);
  .usr-header {
    position: relative;
    //border-bottom: 1px solid #cca352;
    .icon {
      width: 1.5rem;
      height: 1.5rem;
      float: left;
      margin-top: .2rem;
      img {
        height: 100%;
        width: 100%;
      }
    }
    .inf {
      float: left;
      height: 1.5rem;
      margin: 0.3rem 0px 0px 0.3rem;
      text-align: left;
      p {
        color: #fff;
        font-size: 0.45rem;
        font-weight: 700;
      }
      p.usr-id {
        font-size: .35rem;
        font-weight: normal;
      }
      span {
        color: #cca352;
      }
    }
    .arrow {
      position: absolute;
      right: 0px;
      top: 0.8rem;
      color: #cca352;
    }
  }
  .btns {
    margin-top: 10px;
    //border-bottom: 1px solid #cca352;
    padding-bottom: 10px;
    .btn {
      color: #cca352;
      background: #2a2a2e;
      height: 1.1rem;
      line-height: 1.1rem;
      text-align: center;
      width: 96%;
      margin: 0 auto;
    }
  }
  .cols{
    margin-top: 10px;
  }
  .customer-btn{
    width: 80%;
    margin: 15px auto;
    text-align: center;
    height: 1rem;
    line-height: 1rem;
    border:2px solid #cca352;
    color: #cca352;
    font-weight: 700;
  }
  .usdt-des{
    width: 100%;
    text-align: center;
    margin-top: 20px;
    font-size:.35rem;
    color: #999;
    span{
        color: #cca352;
    }
  }
}
</style>
